<template>
  <div>
    <div class="row m-4 mt-0 mb-0">
      <div class="col-sm-12">
        <div class="card card-body mb-0">
          <div class="row">
            <div class="form-group col-sm-12">
              <ul class="navbar-nav overflow-auto flex-row gap-4" >
                <li v-for="(value, tab) in Tabs" :key="tab" class="nav-item nav-item-spaced d-lg-block text-nowrap" >
                  <a href="#" @click.prevent="selectTab(value)" class="nav-link tab" :class="{'active': activeTabName === value}">{{ helper.trans(`currencies.tab.${tab}`) }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <CurrencyRates v-if="activeTabName === Tabs.rates"></CurrencyRates>
      <CurrencyCompare v-if="activeTabName === Tabs.compare"></CurrencyCompare>
    </div>
  </div>
</template>
<script lang="ts">
import {defineComponent, toRefs, reactive} from 'vue'
import {helper} from "@/service/CommonHelper";
import router from "@/router";
import {useRoute} from "vue-router";
import CurrencyRates from "@/views/CurrencyRates.vue";
import CurrencyCompare from "@/views/CurrencyCompare.vue";

enum Tabs {
  rates = 'rates',
  compare = 'compare',

}

export default defineComponent({
  components: {
    CurrencyRates,
    CurrencyCompare,
  },
  setup() {
    const route = useRoute()
    const state = reactive({
      activeTabName: (!route.params.tab ? Tabs.rates : route.params.tab) as Tabs,
    });

    const selectTab = async (value: string) => {
      router.push(`/currencies/${value}`)
      state.activeTabName = value as Tabs
    }


    return {
      ...toRefs(state),
      helper,
      Tabs,
      selectTab
    }
  }
})
</script>
